import { CreditCardOutlined, EnvironmentOutlined } from '@ant-design/icons';
import {
  Col,
  Form,
  Spin,
  VertCheckbox,
  VertInput,
  VertRadio,
  VertTypography,
} from '@vertem-core/vertice-ds';
import SpotltmClient from 'Services/Apis/Spot/ltmApiService';
import { handleAddressNumberOutput } from 'Utils/commons/address';
import { Row } from 'antd';
import MaskedInput from 'pages/newSolicitation/components/InputMask';
import TitleForm from 'pages/newSolicitation/components/TitleForm/TitleForm';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAddressBilling,
  setAddressShipping,
} from 'redux/Reducers/Quotation/ApproveQuotation';
import * as yup from 'yup';

const schema = yup.object().shape({
  zipCode: yup.string().required('Campo obrigatório'),
  address: yup.string().required('Campo obrigatório'),
  number: yup
    .string()
    .required('Número é obrigatório')
    .matches(/^(S\/N|\d+)$/, 'Somente números ou S/N'),
  complement: yup.string().required('Campo obrigatório'),
  neighborhood: yup.string().required('Campo obrigatório'),
  state: yup.string().required('Campo obrigatório'),
  city: yup.string().required('Campo obrigatório'),
  subEnderecoEntregaCep: yup.string().required('Campo obrigatório'),
  subEnderecoEntregaRua: yup.string().required('Campo obrigatório'),
  subEnderecoEntregaNumero: yup
    .string()
    .required('Campo obrigatório')
    .matches(/^(S\/N|\d+)$/, 'Somente números ou S/N'),
  subEnderecoEntregaComplemento: yup.string().required('Campo obrigatório'),
  subEnderecoEntregaBairro: yup.string().required('Campo obrigatório'),
  subEnderecoEntregaEstado: yup.string().required('Campo obrigatório'),
  subEnderecoEntregaCidade: yup.string().required('Campo obrigatório'),
});

export const SpotAdressQuote = ({ isErrorsForm, setIsErrorsForm }) => {
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];
  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [loadingCep, setLoadingCep] = useState(false);
  const [loadingSubEnderecoEntregaCep, setLoadingSubEnderecoEntregaCep] =
    useState(false);

  const [showEnderecoFaturamentoWatch, setShowEnderecoFaturamentoWatch] =
    useState(true);

  const [isCheckboxCheckedNumber, setIsCheckboxCheckedNumber] = useState(
    form.getFieldValue('number') === 'S/N'
  );
  const [isCheckboxCheckedSubNumber, setIsCheckboxCheckedSubNumber] = useState(
    form.getFieldValue('subEnderecoEntregaNumero') === 'S/N'
  );

  useEffect(() => {
    const initialErrors = form.getFieldsError();
    const initialHasErrors = initialErrors.some(
      (field) => field.errors.length > 0
    );
    setIsErrorsForm(initialHasErrors);
  }, []);
  const checkForErrorsAndUpdateState = () => {
    const errors = form.getFieldsError();
    const hasErrors = errors.some((field) => field.errors.length > 0);
    if (hasErrors !== isErrorsForm) {
      setIsErrorsForm(hasErrors);
    }
  };

  useEffect(() => {
    if (form.getFieldValue('number') === 'S/N') {
      return setIsCheckboxCheckedNumber(true);
    }
    setIsCheckboxCheckedNumber(false);
  }, [form.getFieldValue('number')]);

  useEffect(() => {
    if (form.getFieldValue('subEnderecoEntregaNumero') === 'S/N') {
      return setIsCheckboxCheckedSubNumber(true);
    }
    setIsCheckboxCheckedSubNumber(false);
  }, [form.getFieldValue('subEnderecoEntregaNumero')]);

  const { isLoadingSpot, addressShipping } = useSelector(
    (state) => state.ApproveQuotation
  );

  useEffect(() => {
    let addressNumber = handleAddressNumberOutput(addressShipping.number);

    form.setFieldsValue({
      zipCode: addressShipping.zipCode,
      address: addressShipping.address,
      complement: addressShipping.complement,
      neighborhood: addressShipping.neighborhood,
      number: addressNumber,
      state: addressShipping.state,
      city: addressShipping.city,
    });
    form.validateFields();
  }, []);

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  const fetchCep = async (valueCep, name) => {
    const cepRegex = /^[0-9]{8}$/;
    if (!cepRegex.test(valueCep)) {
      return;
    }
    name === 'zipCode'
      ? setLoadingCep(true)
      : setLoadingSubEnderecoEntregaCep(true);

    try {
      const response = await SpotltmClient.get(
        `/cloudloyalty/v1/addresses/${valueCep}`,
        {
          headers: config,
        }
      );

      name === 'zipCode'
        ? setLoadingCep(false)
        : setLoadingSubEnderecoEntregaCep(false);
      if (name === 'zipCode') {
        form.setFieldsValue({
          address: response.data.street,
          neighborhood: response.data.district,
          city: response.data.city,
          state: response.data.state,
        });
        form.resetFields(['number', 'complement']);
      } else {
        form.setFieldsValue({
          subEnderecoEntregaRua: response.data.street,
          subEnderecoEntregaBairro: response.data.district,
          subEnderecoEntregaCidade: response.data.city,
          subEnderecoEntregaEstado: response.data.state,
        });
        form.resetFields([
          'subEnderecoEntregaNumero',
          'subEnderecoEntregaComplemento',
        ]);
      }

      form.validateFields();
    } catch (error) {
      if (error.response && error.response.status === 422) {
        form.setFields([
          {
            name: name,
            errors: ['CEP não encontrado'],
          },
        ]);
      } else {
        form.setFields([
          {
            name: name,
            errors: ['Ocorreu um erro ao buscar o CEP'],
          },
        ]);
        console.info('Ocorreu um erro ao buscar o CEP:', error);
      }
    } finally {
      name === 'zipCode'
        ? setLoadingCep(false)
        : setLoadingSubEnderecoEntregaCep(false);
    }
  };

  return (
    <>
      <Form
        form={form}
        initialValues={{
          zipCode: '',
          address: '',
          complement: '',
          neighborhood: '',
          number: '',
          state: '',
          city: '',
          enderecoSelecionado: 1,
          showEnderecoFaturamento: true,
          subEnderecoEntregaCep: '',
          subEnderecoEntregaRua: '',
          subEnderecoEntregaComplemento: '',
          subEnderecoEntregaBairro: '',
          subEnderecoEntregaNumero: '',
          subEnderecoEntregaEstado: '',
          subEnderecoEntregaCidade: '',
        }}
        autoComplete="off"
        id="formApproveSpot"
        onFieldsChange={checkForErrorsAndUpdateState}
        onBlur={() => {
          form.validateFields();
          dispatch(
            setAddressShipping(
              form.getFieldsValue([
                'zipCode',
                'address',
                'complement',
                'neighborhood',
                'number',
                'state',
                'city',
              ])
            )
          );

          if (!showEnderecoFaturamentoWatch) {
            dispatch(
              setAddressBilling(
                form.getFieldsValue([
                  'subEnderecoEntregaCep',
                  'subEnderecoEntregaRua',
                  'subEnderecoEntregaComplemento',
                  'subEnderecoEntregaBairro',
                  'subEnderecoEntregaNumero',
                  'subEnderecoEntregaEstado',
                  'subEnderecoEntregaCidade',
                ])
              )
            );
          }
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <TitleForm
              icon={<EnvironmentOutlined />}
              title="Endereço de Entrega"
            />

            <VertTypography.Paragraph>
              Aonde deseja que seu pedido seja entregue?
            </VertTypography.Paragraph>

            <div className="box-graft" />

            <Spin spinning={loadingCep}>
              <Form.Item name="zipCode" rules={[yupSync]}>
                <MaskedInput
                  mask="99999-999"
                  label="CEP"
                  onChange={(e) => {
                    const value = e.replace(/[^0-9]/g, '');

                    if (value.length === 8) {
                      fetchCep(value, 'zipCode');
                    }
                  }}
                  disabled={isLoadingSpot}
                />
              </Form.Item>

              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item name="address" rules={[yupSync]}>
                    <VertInput label="Rua" disabled={isLoadingSpot} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item name="number" rules={[yupSync]}>
                    <VertInput
                      label="Número"
                      disabled={isLoadingSpot || isCheckboxCheckedNumber}
                    />
                  </Form.Item>
                  <VertCheckbox
                    onClick={() => {
                      const currentValue = form.getFieldValue('number');
                      if (currentValue === 'S/N') {
                        form.setFieldsValue({
                          number: '',
                        });
                        form.validateFields(['number']);

                        setIsCheckboxCheckedNumber(false);
                      } else {
                        form.setFieldsValue({
                          number: 'S/N',
                        });
                        setIsCheckboxCheckedNumber(true);
                      }
                    }}
                    checked={isCheckboxCheckedNumber}
                    className="vert-checkbox-address"
                  >
                    Sem número
                  </VertCheckbox>
                </Col>
              </Row>

              <Form.Item name="complement" rules={[yupSync]}>
                <VertInput label="Complemento" disabled={isLoadingSpot} />
              </Form.Item>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item name="neighborhood" rules={[yupSync]}>
                    <VertInput label="Bairro" disabled={isLoadingSpot} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item name="state" rules={[yupSync]}>
                    <VertInput label="Estado" disabled={isLoadingSpot} />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item name="city" rules={[yupSync]}>
                <VertInput label="Cidade" disabled={isLoadingSpot} />
              </Form.Item>
            </Spin>
          </Col>

          <Col xs={24} sm={12}>
            <TitleForm
              icon={<CreditCardOutlined />}
              title="Endereço de Faturamento"
            />
            <VertTypography.Paragraph>
              Onde deseja que seu pedido seja entregue?
            </VertTypography.Paragraph>
            <div className="box-show-endereco-entrega-spot">
              <Form.Item name="showEnderecoFaturamento">
                <VertCheckbox
                  name="showEnderecoFaturamento"
                  defaultChecked={true}
                  onChange={(e) => {
                    setShowEnderecoFaturamentoWatch(e.target.checked);
                    form.resetFields([
                      'subEnderecoEntregaCep',
                      'subEnderecoEntregaRua',
                      'subEnderecoEntregaComplemento',
                      'subEnderecoEntregaBairro',
                      'subEnderecoEntregaNumero',
                      'subEnderecoEntregaEstado',
                      'subEnderecoEntregaCidade',
                    ]);
                  }}
                  value={!showEnderecoFaturamentoWatch}
                >
                  O endereço de Fatuamento é o mesmo do endereço de Entrega
                </VertCheckbox>
              </Form.Item>
            </div>

            {!showEnderecoFaturamentoWatch && (
              <>
                <Spin spinning={loadingSubEnderecoEntregaCep}>
                  <Form.Item name="subEnderecoEntregaCep" rules={[yupSync]}>
                    <MaskedInput
                      mask="99999-999"
                      label="CEP"
                      onChange={(e) => {
                        const value = e.replace(/[^0-9]/g, '');

                        if (value.length === 8) {
                          fetchCep(value, 'subEnderecoEntregaCep');
                        }
                      }}
                    />
                  </Form.Item>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item name="subEnderecoEntregaRua" rules={[yupSync]}>
                        <VertInput label="Rua" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="subEnderecoEntregaNumero"
                        rules={[yupSync]}
                      >
                        <VertInput
                          label="Número"
                          disabled={isCheckboxCheckedSubNumber}
                        />
                      </Form.Item>
                      <VertCheckbox
                        onClick={() => {
                          const currentValue = form.getFieldValue(
                            'subEnderecoEntregaNumero'
                          );
                          if (currentValue === 'S/N') {
                            form.setFieldsValue({
                              subEnderecoEntregaNumero: '',
                            });
                            form.validateFields(['subEnderecoEntregaNumero']);

                            setIsCheckboxCheckedSubNumber(false);
                          } else {
                            form.setFieldsValue({
                              subEnderecoEntregaNumero: 'S/N',
                            });
                            setIsCheckboxCheckedSubNumber(true);
                          }
                        }}
                        checked={isCheckboxCheckedSubNumber}
                        className="vert-checkbox-address"
                      >
                        Sem número
                      </VertCheckbox>
                    </Col>
                  </Row>

                  <Form.Item
                    name="subEnderecoEntregaComplemento"
                    rules={[yupSync]}
                  >
                    <VertInput label="Complemento" />
                  </Form.Item>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="subEnderecoEntregaBairro"
                        rules={[yupSync]}
                      >
                        <VertInput label="Bairro" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="subEnderecoEntregaEstado"
                        rules={[yupSync]}
                      >
                        <VertInput label="Estado" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item name="subEnderecoEntregaCidade" rules={[yupSync]}>
                    <VertInput label="Cidade" />
                  </Form.Item>
                </Spin>
              </>
            )}
          </Col>
        </Row>
      </Form>
    </>
  );
};
